<template>
  <div>
    <app-cells><h1 class="title">Fingerprint test 1.10</h1></app-cells>
    <app-cells>
      <app-button @click.native="onFingerprintInit" ref="start" theme="info">Start</app-button>
      <app-button @click.native="onIdentifyInit" ref="start_identify" theme="warn">Identify</app-button>
    </app-cells>
    <modal
      name="fingerprint"
      :width="400"
      :height="'auto'"
      :scrollable="true"
      :adaptive="true"
      :clickToClose="false"
      draggable=".popup__title"
      class="modal-not-overflow"
    >
      <div class="popup">
        <button @click="$modal.hide('fingerprint')" class="popup__close" type="button"></button>
        <div class="popup__title">Scan</div>
        <div class="popup__body">
          <form style="text-align: center">
            <img v-if="is_img_show" :src="`http://localhost:5678/img/PreviewStreaming.bmp?dummy=${Math.random()}&shandle=${device_handle}&id=0`" alt="">
            <img v-if="image_base64" :src="`data:image/png;base64,${image_base64}`" alt="" />
            <app-cells v-if="info_message">
              <p>{{ info_message }}</p>
            </app-cells>
            <app-cells position="center">
              <app-button v-if="!info_message" @click.native="onFingerprintScan" theme="info" ref="scan">Capture</app-button>
              <template v-else>
                <app-button @click.native="onRetry" theme="warn">Retry</app-button>
                <app-button @click.native="$modal.hide('fingerprint')" :disabled="!template_base64">Save</app-button>
              </template>
            </app-cells>
          </form>
        </div>
      </div>
    </modal>
    <modal
      name="identify"
      :width="540"
      :height="'auto'"
      :scrollable="true"
      :adaptive="true"
      :clickToClose="false"
      draggable=".popup__title"
      class="modal-not-overflow"
    >
      <div class="popup">
        <button @click="$modal.hide('identify')" class="popup__close" type="button"></button>
        <div class="popup__title">Identify</div>
        <app-cells>
          Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.
        </app-cells>
        <div class="popup__body">
          <form style="text-align: center">
            <img v-if="is_img_show" :src="`http://localhost:5678/img/PreviewStreaming.bmp?dummy=${Math.random()}&shandle=${device_handle}&id=0`" alt="">
            <app-cells v-if="info_message">
              <p>{{ info_message }}</p>
            </app-cells>
            <app-cells position="center">
              <app-button @click.native="onIdentifyStart" theme="info" ref="identify">Identify</app-button>
            </app-cells>
          </form>
        </div>
      </div>
    </modal>
  </div>
</template>

<script>
import { defineComponent } from 'vue'
// import axios from 'axios'
import {
  getFingerprintImageData,
  getFingerprintInitDevice,
  getFingerprintScannerStatus,
  getFingerprintSetParameters,
  getFingerprintStartCapturing,
  getFingerprintTemplateData,
  postEmployeesFingerprintsIdentify,
} from '@/http'

export default defineComponent({
  name: 'Fingerprint',
  data() {
    return {
      device_handle: null,
      template_base64: '',
      image_base64: null,
      info_message: '',
      is_img_show: false,
    }
  },
  methods: {
    onIdentifyInit() {
      if (!this.device_handle) {
        this.$refs.start_identify.preload = true
        getFingerprintInitDevice(Math.random())
          .finally(() => { this.$refs.start_identify.preload = false })
          .then(res => {
            if (res.data.retValue !== '0') {
              this.$notify({
                type: 'error',
                title: res.data.retString,
              })
            } else {
              this.$notify({
                type: 'success',
                title: `Scanner ${res.data.ScannerInfos[0].ScannerName} found. You can keep working`,
              })
              this.device_handle = res.data.ScannerInfos[0].DeviceHandle
              this.$modal.show('identify')
            }
          })
          .catch(() => {
            this.$notify({
              type: 'error',
              title: 'Something went wrong on initDevice',
            })
          })
      } else {
        this.$modal.show('identify')
      }
    },
    onIdentifyStart() {
      this.$refs.identify.preload = true
      getFingerprintStartCapturing(Math.random(), this.device_handle)
        .then(() => {
          this.getIdentifyStatus()
          this.is_img_show = true
        })
    },
    getIdentifyStatus() {
      getFingerprintScannerStatus(Math.random(), this.device_handle)
        .then(res => {
          if (res.data.IsCapturing === 'false') {
            this.setIdentifyParameters()
          } else {
            setTimeout(this.getIdentifyStatus, 200)
          }
        })
    },
    setIdentifyParameters() {
      getFingerprintSetParameters(Math.random(), this.device_handle, 2002)
        .then(() => {
          getFingerprintTemplateData(Math.random(), this.device_handle)
            .then(res => {
              if (res.data.retValue !== '0') {
                this.$notify({
                  type: 'error',
                  title: res.data.retString,
                })
                this.info_message = 'Scan error'
              } else {
                postEmployeesFingerprintsIdentify({ template: res.data.templateBase64 })
                  .then(res => {
                    this.$router.push({ name: 'employees-profile', params: { id: res.data.person.board_id } })
                  })
                  .catch(error => {
                    this.$notify({
                      type: 'error',
                      title: error.response.data.detail
                    })
                    this.$modal.hide('identify')
                  })
              }
            })
        })
    },
    onOpenPopup() {
      this.$modal.show('fingerprint')
    },
    onRetry() {
      this.template_base64 = ''
      this.image_base64 = null
      this.info_message = ''
      this.is_img_show = false
      this.onFingerprintScan()
    },
    getTemplateData() {
      getFingerprintTemplateData(Math.random(), this.device_handle)
        .then(res => {
          if (res.data.retValue !== '0') {
            this.$notify({
              type: 'error',
              title: res.data.retString,
            })
            this.info_message = 'Scan error'
          } else {
            this.template_base64 = res.data.templateBase64
            this.info_message = 'Scan was successful'
          }
        })
    },
    getImageData() {
      getFingerprintImageData(Math.random(), this.device_handle)
        .then(res => {
          if (res.data.retValue !== '0') {
            this.$notify({
              type: 'error',
              title: res.data.retString,
            })
          } else {
            this.is_img_show = false
            this.image_base64 = res.data.imageBase64
            this.getTemplateData()
          }
        })
    },
    getCaptureEnd() {
      // axios.get(`http://localhost:5678/api/getCaptureEnd?dummy=${Math.random()}&sHandle=${this.device_handle}&id=0`)
      //   .finally(() => { this.$refs.scan.preload = false })
      //   .then(res => {
      //     if (res.data.IsFingerOn !== true) setTimeout(this.getCaptureEnd, 200)
      //     else this.getTemplateData()
      //   })
      getFingerprintScannerStatus(Math.random(), this.device_handle)
        .finally(() => { this.$refs.scan.preload = false })
        .then(res => {
          if (res.data.IsCapturing === 'false') {
            this.getImageData()
          } else {
            setTimeout(this.getCaptureEnd, 200)
          }
        })
    },
    onFingerprintScan() {
      getFingerprintStartCapturing(Math.random(), this.device_handle)
        .then(() => {
          this.getCaptureEnd()
          this.is_img_show = true
        })
    },
    getScannerStatus() {
      this.$refs.scan.preload = true
      getFingerprintScannerStatus(Math.random(), this.device_handle)
        .then(res => {
          if (res.data.IsCapturing === 'false') {
            this.onFingerprintScan()
          } else {
            setTimeout(this.getScannerStatus, 200)
          }
        })
    },
    onFingerprintInit() {
      this.$refs.start.preload = true
      getFingerprintInitDevice(Math.random())
        .finally(() => { this.$refs.start.preload = false })
        .then(res => {
          if (res.data.retValue !== '0') {
            this.$notify({
              type: 'error',
              title: res.data.retString,
            })
          } else {
            this.$notify({
              type: 'success',
              title: `Scanner ${res.data.ScannerInfos[0].ScannerName} found. You can keep working`,
            })
            this.device_handle = res.data.ScannerInfos[0].DeviceHandle
            this.onOpenPopup()
          }
        })
        .catch(() => {
          this.$notify({
            type: 'error',
            title: 'Something went wrong on initDevice',
          })
        })
    }
  }
})
</script>
